<app-button *ngIf="rawFilters" mode="secondary" class="opleiding-overzicht__result-button" data-cy="filterResultsButton" (clicked)="openFilterModal()">
  {{'filter.results' | content: { TOTAAL: total} }}
</app-button>
